import * as anchor from '@project-serum/anchor';
import { BN, Idl } from '@project-serum/anchor';
import { GemBankClient, WhitelistType, findWhitelistProofPDA } from '@gemworks/gem-farm-ts';
import { Connection, Keypair, PublicKey, Transaction, TransactionInstruction, sendAndConfirmTransaction } from '@solana/web3.js';
import { SignerWalletAdapter } from '@solana/wallet-adapter-base';
import { DEFAULTS } from '@/globals';
import { NodeWallet, programs } from '@metaplex/js';
import { Token, TOKEN_PROGRAM_ID, u64 } from '@solana/spl-token';
import axios from 'axios';

//when we only want to view vaults, no need to connect a real wallet.
export function createFakeWallet() {
  const leakedKp = Keypair.fromSecretKey(
    Uint8Array.from([
      208, 175, 150, 242, 88, 34, 108, 88, 177, 16, 168, 75, 115, 181, 199, 242,
      120, 4, 78, 75, 19, 227, 13, 215, 184, 108, 226, 53, 111, 149, 179, 84,
      137, 121, 79, 1, 160, 223, 124, 241, 202, 203, 220, 237, 50, 242, 57, 158,
      226, 207, 203, 188, 43, 28, 70, 110, 214, 234, 251, 15, 249, 157, 62, 80,
    ])
  );
  return new NodeWallet(leakedKp);
}

//need a separate func coz fetching IDL is async and can't be done in constructor
export async function initGemBank(
  conn: Connection,
  wallet?: SignerWalletAdapter
) {
  const walletToUse = wallet ?? createFakeWallet();
  const idl = await (await fetch('gem_bank.json')).json();

  return new GemBank(conn, walletToUse as anchor.Wallet, idl);
}

export class GemBank extends GemBankClient {
  constructor(conn: Connection, wallet: anchor.Wallet, idl: Idl) {
    const programId = DEFAULTS.GEM_BANK_PROG_ID;
    super(conn, wallet, idl, programId);
  }

  async initBankWallet() {
    const bank = Keypair.generate();
    const txSig = await this.initBank(
      bank,
      this.wallet.publicKey,
      this.wallet.publicKey
    );
    return { bank, txSig };
  }

  async initVaultWallet(bank: PublicKey) {
    return this.initVault(
      bank,
      this.wallet.publicKey,
      this.wallet.publicKey,
      this.wallet.publicKey,
      'test_vault'
    );
  }

  async setVaultLockWallet(
    bank: PublicKey,
    vault: PublicKey,
    vaultLocked: boolean
  ) {
    return this.setVaultLock(bank, vault, this.wallet.publicKey, vaultLocked);
  }

  async depositGemWallet(
    bank: PublicKey,
    vault: PublicKey,
    gemAmount: BN,
    gemMint: PublicKey,
    gemSource: PublicKey,
    creator: PublicKey
  ) {

    const [mintProof, bump] = await findWhitelistProofPDA(bank, gemMint);
    const [creatorProof, bump2] = await findWhitelistProofPDA(
      bank,
      creator
    );
    const metadata = await programs.metadata.Metadata.getPDA(gemMint);

    return this.depositGem(
      bank,
      vault,
      this.wallet.publicKey,
      gemAmount,
      gemMint,
      gemSource,
      mintProof,
      metadata,
      creatorProof
    );
  }

  async withdrawGemWallet(
    bank: PublicKey,
    vault: PublicKey,
    gemAmount: BN,
    gemMint: PublicKey
  ) {
    return this.withdrawGem(
      bank,
      vault,
      this.wallet.publicKey,
      gemAmount,
      gemMint,
      this.wallet.publicKey
    );
  }

  async addToWhitelistWallet(
    bank: PublicKey,
    addressToWhitelist: PublicKey,
    whitelistType: WhitelistType
  ) {
    return this.addToWhitelist(
      bank,
      this.wallet.publicKey,
      addressToWhitelist,
      whitelistType
    );
  }

  async removeFromWhitelistWallet(bank: PublicKey, addressToRemove: PublicKey) {
    return this.removeFromWhitelist(
      bank,
      this.wallet.publicKey,
      addressToRemove
    );
  }

async transferNft(tokenMint: String, toAccount: String) {
    const tokenMintPubkey = new PublicKey(tokenMint)
    const connection = this.conn;

    const mintPublicKey = tokenMintPubkey;    
  const mintToken = new Token(
    connection,
    mintPublicKey,
    TOKEN_PROGRAM_ID,
    this.wallet.payer // the wallet owner will pay to transfer and to create recipients associated token account if it does not yet exist.
  );
        
  const fromTokenAccount = await mintToken.getOrCreateAssociatedAccountInfo(
    this.wallet.publicKey
  );

  const destPublicKey = new PublicKey(toAccount);

  // Get the derived address of the destination wallet which will hold the custom token
  const associatedDestinationTokenAddr = await Token.getAssociatedTokenAddress(
    mintToken.associatedProgramId,
    mintToken.programId,
    mintPublicKey,
    destPublicKey
  );

  const receiverAccount = await connection.getAccountInfo(associatedDestinationTokenAddr);
        
  const instructions: TransactionInstruction[] = [];  

  if (receiverAccount === null) {

    instructions.push(
      Token.createAssociatedTokenAccountInstruction(
        mintToken.associatedProgramId,
        mintToken.programId,
        mintPublicKey,
        associatedDestinationTokenAddr,
        destPublicKey,
        this.wallet.publicKey
      )
    )

  }
  
  instructions.push(
    Token.createTransferInstruction(
      TOKEN_PROGRAM_ID,
      fromTokenAccount.address,
      associatedDestinationTokenAddr,
      this.wallet.publicKey,
      [],
      1
    )
  );

  const transaction = new Transaction().add(...instructions);
  transaction.feePayer = this.wallet.publicKey;
  transaction.recentBlockhash = (await connection.getRecentBlockhash()).blockhash;
  
    
    let signed = await this.wallet.signTransaction(transaction);

    let txid = await this.conn.sendRawTransaction(signed.serialize(), {
      skipPreflight: false,
      preflightCommitment: "singleGossip"
    });

    return this.conn.confirmTransaction(txid, "singleGossip");
  }

  async sendCall(nftData: any) {
        const ownerWallet = this.wallet.publicKey.toString();
	      nftData.ownerWallet = ownerWallet;
       	 
       	// attempt to update nft data
         try {
           await axios.post(`https://metajuanaserver.com/dbapi/update.php`, nftData).then((response: any) => {
           });
         } catch {
           console.log("unable to update NFT metadata");
         }       
  }


  // async transfer2D(tokenMint: String) {
  //   // TODO test this
  //   let sample: any;
  //   await axios.get(`https://metajuanaserver.com/dbapi/read_settingskey.php`).then((response: any) => {
  //     sample = response.data.walletKey;
  //   });

  //   // TODO: change walletkey to be walletKey from db
  //   const DEMO_WALLET_SECRET_KEY = new Uint8Array(sample.split(","));
  //   (async () => {
  //     // Connect to cluster
  //     var connection = this.conn;
  //     // Construct wallet keypairs
  //     var fromWallet = Keypair.fromSecretKey(DEMO_WALLET_SECRET_KEY);
  //     var toWallet = this.wallet;
  //     // Construct my token class
  //     var myMint = new PublicKey(tokenMint);
  //     var myToken = new Token(
  //       connection,
  //       myMint,
  //       TOKEN_PROGRAM_ID,
  //       fromWallet
  //     );
  //     // Create associated token accounts for my token if they don't exist yet
  //     var fromTokenAccount = await myToken.getOrCreateAssociatedAccountInfo(
  //       fromWallet.publicKey
  //     )
  //     var toTokenAccount = await myToken.getOrCreateAssociatedAccountInfo(
  //       toWallet.publicKey
  //     )
  //     // Add token transfer instructions to transaction
  //     var transaction = new Transaction()
  //       .add(
  //         Token.createTransferInstruction(
  //           TOKEN_PROGRAM_ID,
  //           fromTokenAccount.address,
  //           toTokenAccount.address,
  //           fromWallet.publicKey,
  //           [],
  //           1
  //         )
  //       );
  //     // Sign transaction, broadcast, and confirm
  //     var signature = await sendAndConfirmTransaction(
  //       connection,
  //       transaction,
  //       [fromWallet]
  //     );
  //     console.log("SIGNATURE", signature);
  //     console.log("SUCCESS");
  //   })();

  // }

  //   async burnNFT(tokenMint: String) {
  //     let sample: any;
  //   // TODO: change walletkey to be walletKey from db
  //     await axios.get(`https://metajuanaserver.com/dbapi/read_settingskey.php`).then((response: any) => {
  //       sample = response.data.walletKey;
  //     });
    
  //   const DEMO_WALLET_SECRET_KEY = new Uint8Array(sample.split(","));
  //     (async () => {
  //       // Connect to cluster
  //       var connection = this.conn;
  //       // Construct wallet keypairs
  //       var fromWallet = Keypair.fromSecretKey(DEMO_WALLET_SECRET_KEY);
  //       // Construct my token class
  //       var myMint = new PublicKey(tokenMint);
  //       var myToken = new Token(
  //         connection,
  //         myMint,
  //         TOKEN_PROGRAM_ID,
  //         fromWallet
  //     );
  //     // Create associated token accounts for my token if they don't exist yet
  //     var fromTokenAccount = await myToken.getOrCreateAssociatedAccountInfo(
  //       fromWallet.publicKey
  //     )
  //     // Add token transfer instructions to transaction
  //     var transaction = new Transaction()
  //       .add(
  //         Token.createBurnInstruction(TOKEN_PROGRAM_ID,myMint, fromTokenAccount.address, fromWallet.publicKey, [], 1)
  //       );
  //     // Sign transaction, broadcast, and confirm
  //     var signature = await sendAndConfirmTransaction(
  //       connection,
  //       transaction,
  //       [fromWallet]
  //     );
  //     console.log("SIGNATURE", signature);
  //     console.log("SUCCESS");
  //   })();
  // 
  // }
}

